import { action } from 'satcheljs';
/**
 * Launches Edit Group Success Action
 */
export default action('EDIT_GROUP_SUCCESS', function (groupSmtp) {
    return {
        groupSmtp: groupSmtp,
    };
});
//# sourceMappingURL=editGroupSuccess.js.map